import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'documentState';

export const getAllDocuments = createAsyncThunk(
    'documentStore/getAll',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/documents`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            console.error('ERROR FETCHING DOCUMENTS', error);
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    documents: [],
    activeDocument: null,
    status: 'idle',
    error: null,
};

const documentSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setActive: (state, action) => {
            state.activeDocument = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllDocuments.pending, (state) => {
                state.status = 'loading';
                state.error = null; 
            })
            .addCase(getAllDocuments.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.documents = action.payload; 
                state.activeDocument = action.payload.length > 0 ? action.payload[0] : null;
            })
            .addCase(getAllDocuments.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred'; 
            });
    },
});

export const { setActive } = documentSlice.actions;

export default documentSlice.reducer;